
<template>
  <Select v-model="model" clearable multiple filterable transfer @on-change="onChange">
    <Option v-for="item in adminUserList" :value="item.id" :key="item.id">{{ item.nickname + ' - ' + item.phone }}</Option>
  </Select>
</template>
<script>  export default {
    name: 'AdminUserMultSelect',
    props: {
      value: {
        type: Array, // 修改为数组类型
      },
      status: {
        type: [Number, String],
        default: 1
      },
      adminGroupCode: {
        type: String,
        default: ''
      },
      groupTitles: {
        type: Array,
        default: function () {
          return []
        }
      },
      needDefaultStudyAdviser: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        adminGroupList: [{id: 4, code: 'userStudyAdviser'}, {id: 6, code: 'marketGroup'}, {id: 7, code: 'tchStudyAdviser'}, {id: 10, code: 'adviser'}],
        adminUserList: [],
        model: [] // 修改为数组类型
      }
    },
    methods: {
      getAdminGroupId () {
        let adminGroupId = ''
        if (this.adminGroupCode === '') {
          return adminGroupId
        }
        let code = this.adminGroupCode
        this.adminGroupList.forEach(element => {
          if (element.code === code) {
            adminGroupId = element.id
            return
          }
        })
        return adminGroupId
      },
      onChange (value) {
        this.$emit('input', value)
      },
      loadByGroupTitles () {
        let self = this
        let wanted = {}
        self.groupTitles.forEach(function (title) {
          wanted[(title || '').trim()] = true
        })
        self.$http.get('/adminGroup/listByCondition', {params: {status: 1}}).then(function (res) {
          let groups = res && res.data ? res.data : []
          if (!Array.isArray(groups)) {
            groups = groups.data || []
          }
          let ids = []
          groups.forEach(function (group) {
            let title = ((group && group.title) || '').trim()
            if (wanted[title]) {
              ids.push(group.id)
            }
          })
          if (!ids.length) {
            self.adminUserList = []
            return
          }
          self.$http.post('/adminUser/listByCondition', {status: self.status, groupIds: ids}).then(function (userRes) {
            let list = userRes && userRes.data ? userRes.data : []
            if (!Array.isArray(list)) {
              list = []
            }
            let seen = {}
            self.adminUserList = list.filter(function (user) {
              if (!user || seen[user.id]) {
                return false
              }
              seen[user.id] = true
              return true
            })
          })
        })
      }
    },
    mounted: function () {
      let self = this
      if (self.groupTitles && self.groupTitles.length) {
        self.loadByGroupTitles()
        return
      }
      let params = { status: self.status, adminGroupId: self.getAdminGroupId(), needDefaultStudyAdviser: self.needDefaultStudyAdviser }
      self.$http.get('/adminUser/listByCondition', { params: params }).then(function (res) {
        if (res && res.data) {
          self.adminUserList = res.data
        } else {
          self.adminUserList = []
        }
      })
    },
    watch: {
      value (val) {
        if (val) {
          this.model = val
        } else {
          this.model = []
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AdminUserMultSelect.vue?72f6d4bd